export default __webpack_public_path__ + "static/year-one-hero-12a4078172b74a0c8967a6419e0aea5c.jpg";